import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import { useNavigate } from "react-router-dom";


import './css/login_page.css';
import api from '../../utils/webcall';
import UserProfile from '../../components/User';
import { Paper } from '@mui/material';
import { timeout, getErrorMessage } from '../../utils/utils';

function LoginPage(props) {
    const { showErrorMessage } = props;
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (UserProfile.isLoggedIn()) {
            navigate("/home");
        }
    }, [navigate]);

    const handleLoginButtonClick = (e) => {
        e.preventDefault();
        setLoading(true);
        api.post(`/auth/login/`, { username, password }).then((res) => {
            if (res.status === 200) {
                let data = res.data;
                UserProfile.setAuth(data['access'], data['refresh']);
                api.get(`/auth/user/details/`, {}).then((res) => {
                    if (res.status === 200) {
                        let data = res.data;
                        UserProfile.setUserData(data);
                        timeout(1000).then(() => {
                            console.log("Navigating to /home");
                            navigate('/home');
                        })
                    }
                    else {
                        showErrorMessage(res.status + " " + res.message);
                    }
                }).catch((error) => {
                    showErrorMessage(getErrorMessage(error));
                });
            }
            else {
                showErrorMessage(getErrorMessage(res));
            }
        }).catch((error) => {
            if (error?.response?.status === 401) {
                setError('Invalid Credentials');
                showErrorMessage('Invalid Credentials');
            }
            else {
                const message = getErrorMessage(error);
                setError(message);
                showErrorMessage(message);
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    return (
        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh' }}>
            <Grid size={{ xs: 11, sm: 8, md: 5, lg: 4, xl: 3 }}>
                <Paper elevation={4} sx={{ p: { xs: 2, sm: 4 }, textAlign: 'center', borderRadius: 3, backgroundColor: (theme) => theme.palette.background.paper }}>
                    <h2 style={{ marginBottom: 8 }}>DIVASH Store Management</h2>
                    <form onSubmit={handleLoginButtonClick} autoComplete="on">
                        <Grid container direction="column" spacing={3}>
                            <Grid>
                                <TextField
                                    id="username-input"
                                    label="Username"
                                    variant="outlined"
                                    fullWidth
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    autoComplete="username"
                                    InputProps={{ sx: { borderRadius: 2 } }}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="password-input"
                                    label="Password"
                                    variant="outlined"
                                    fullWidth
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    autoComplete="current-password"
                                    InputProps={{
                                        endAdornment: (
                                            <Button
                                                variant="text"
                                                size="small"
                                                onClick={() => setShowPassword((prev) => !prev)}
                                                sx={{ minWidth: 60 }}
                                            >
                                                {showPassword ? "Hide" : "Show"}
                                            </Button>
                                        ),
                                        sx: { borderRadius: 2 }
                                    }}
                                />
                            </Grid>
                            {error && (
                                <Grid>
                                    <div className="error" style={{ color: '#d32f2f', fontSize: 14 }}>{error}</div>
                                </Grid>
                            )}
                            <Grid>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    disabled={loading}
                                    type="submit"
                                    sx={{ py: 1.5, borderRadius: 2, fontWeight: 600, fontSize: 16 }}
                                >
                                    {loading ? <CircularProgress size={24} /> : "Login"}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Paper>
            </Grid>
        </Grid>
    );
}

export default LoginPage;
